module.exports = __webpack_public_path__ + "media/images/map/add-address-img-3f9c819997da76ee95be50690dc33b98.png";